import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi';
import type {ExperienceList} from '../type/experiences';
export interface ExperienceListOptionsProps {
  sortOrder?: 'asc' | 'desc';
  sortBy?: 'created_at' | 'ee_current_price';
  limit?: number;
  page?: number;
  celebrityId?: number[];
  favoritesOnly?: boolean;
  status?: string[];
  types?: string[];
  tags?: string[];
  sortByPrice?: 'asc' | 'desc' | null;
  sortByViews?: 'asc' | 'desc' | null;
  sortByFavorites?: 'asc' | 'desc' | null;
  sortByNew?: 'asc' | 'desc' | null;
  minCurrentPrice?: number;
  maxCurrentPrice?: number;
  category?: 'EXCLUSIVE_EXPERIENCE' | 'DIGITAL_EXPERIENCE' | 'EXCLUSIVE_ITEM' | 'all';
  celebrityName?: string;
}

export const experiencesListOptions = ({
  sortOrder,
  sortBy,
  limit,
  page,
  celebrityId,
  favoritesOnly,
  status,
  minCurrentPrice,
  maxCurrentPrice,
  types: type,
  tags,
  category,
  celebrityName,
}: ExperienceListOptionsProps) =>
  queryOptions({
    queryKey: [
      'experiences-list',
      sortOrder,
      sortBy,
      limit,
      page,
      celebrityId,
      status,
      minCurrentPrice,
      maxCurrentPrice,
      type,
      tags,
      favoritesOnly,
      category,
      celebrityName,
    ],
    queryFn: async () => {
      try {
        const $api = await api();
        // Сериализация параметров вручную
        const params = new URLSearchParams();

        if (sortOrder) params.set('sortOrder', sortOrder);
        if (sortBy) params.set('sortBy', sortBy);
        if (typeof limit === 'number') params.set('limit', String(limit));
        if (typeof page === 'number') params.set('page', String(page));
        if (favoritesOnly) params.set('favoritesOnly', String(favoritesOnly));
        if (typeof minCurrentPrice === 'number') params.set('minCurrentPrice', String(minCurrentPrice));
        if (typeof maxCurrentPrice === 'number') params.set('maxCurrentPrice', String(maxCurrentPrice));
        if (category && category !== 'all') params.set('category', String(category));
        if (Array.isArray(celebrityId)) {
          for (const id of celebrityId) {
            // ключ повторяется без []
            params.append('celebrityId', String(id));
          }
        }
        if (type) {
          for (const t of type) {
            params.append('type', String(t));
          }
        }
        if (tags) {
          for (const t of tags) {
            params.append('tags', String(t));
          }
        }
        if (celebrityName) params.set('celebrityName', celebrityName);

        const response = await $api.get<ExperienceList>('/ee', {
          params,
          paramsSerializer: p => (p as URLSearchParams).toString(),
        });

        return response.data;
      } catch (error) {
        console.error('Failed to fetch experiences:', JSON.stringify(error));
        return {
          items: [],
          totalCount: 0,
          totalPagesCount: 0,
        };
      }
    },

    // Добавляем настройки для лучшей работы с SSG
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: 1, // Только одна попытка повтора
  });
